// ABOUTME: Start-up loading screen — TE mark, indeterminate bar, caption on the light backdrop.
// ABOUTME: React twin of the pre-bundle loader in index.html, so the hand-off to React doesn't jump.

import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { cn } from "@shared/lib/utils"
// Imported, not referenced by public-root path: the design system ships this component
// outside the app, where "/logo-te-mark.svg" resolves against a host that does not have it.
import logoMark from "@/assets/img/logo-te-mark.svg"

interface CAppLoadingProps {
  /** What we are waiting for. Defaults to "loading the app". */
  note?: string
  className?: string
}

export const CAppLoading: FC<CAppLoadingProps> = ({ note, className }) => {
  const { t } = useTranslation()

  return (
    <div
      role="status"
      className={cn(
        "flex min-h-dvh flex-col items-center justify-center gap-4.5 bg-customGray-100 px-5 py-12",
        className,
      )}
    >
      <img
        src={logoMark}
        alt=""
        width={48}
        height={48}
        className="h-12 w-12 animate-pulse"
      />
      {/* The byte counter lives in the HTML loader, which is the only place that can
          measure the bundle; here the bar only says "still working". */}
      <div className="relative h-1 w-50 overflow-hidden rounded-full bg-border">
        <div className="absolute inset-y-0 left-0 w-1/4 animate-[loading-bar_1.2s_ease-in-out_infinite] rounded-full bg-primary" />
      </div>
      <p className="text-sm font-medium text-gray-600">{note ?? t("common.loadingApp")}</p>
    </div>
  )
}
